import React from 'react';
import { BodyText, Column, Row } from '@chargify/custom-ui-components';

export type DetailsRowProps = {
  label: string;
  value: string;
  hint?: string;
};
const DetailRow = ({ label, value, hint }: DetailsRowProps) => {
  if (!value) return null;
  return (
    <Column span={24}>
      <Row rowGap={'2'}>
        <Column span={[24, 8]}>
          <div data-testid="detail-label">
            <BodyText variant="body2" color={'gray.dark'} fontWeight={2}>
              {label}
            </BodyText>
          </div>
        </Column>
        <Column span={[24, 16]}>
          {hint && (
            <BodyText variant={'body3'} color={'gray.dark'}>
              {hint}
            </BodyText>
          )}
          <BodyText variant="body2" color={'black.main'} overflow="break-word">
            {value}
          </BodyText>
        </Column>
      </Row>
    </Column>
  );
};
export default DetailRow;
